/**
 * @generated SignedSource<<57e8668d9fe3c9f67ee75bb15b6e474f>>
 * @relayHash ea7172d4f00c5846ec23ab207abff057
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e

import type { ConcreteRequest } from 'relay-runtime';
export type ExternalShareMediaDownloadTokenQuery$variables = {
  contentId: string;
};
export type ExternalShareMediaDownloadTokenQuery$data = {
  readonly mediaConfiguration: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  } | null;
  readonly singleContent: {
    readonly body: {
      readonly atlas_doc_format: {
        readonly mediaToken: {
          readonly token: string | null;
        } | null;
      } | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type ExternalShareMediaDownloadTokenQuery = {
  response: ExternalShareMediaDownloadTokenQuery$data;
  variables: ExternalShareMediaDownloadTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentBody",
            "kind": "LinkedField",
            "name": "atlas_doc_format",
            "plural": false,
            "selections": [
              {
                "concreteType": "EmbeddedMediaToken",
                "kind": "LinkedField",
                "name": "mediaToken",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "token"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "MediaConfiguration",
    "kind": "LinkedField",
    "name": "mediaConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "clientId"
      },
      {
        "kind": "ScalarField",
        "name": "fileStoreUrl"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ExternalShareMediaDownloadTokenQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalShareMediaDownloadTokenQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ea7172d4f00c5846ec23ab207abff057",
    "id": "def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e",
    "metadata": {},
    "name": "ExternalShareMediaDownloadTokenQuery",
    "operationKind": "query",
    "text": "query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{mediaToken{token}}}},mediaConfiguration{clientId,fileStoreUrl}}"
  }
};
})();

(node as any).hash = "3592e1b2dcd3aa2c38a177d9b363dafe";

export default node;
